/**
 * @file
 * Global utilities.
 *
 */
(function ($, Drupal) {
  "use strict";

  Drupal.behaviors.google_ads = {
    attach: function (context, settings) {
      if (
        document.getElementById("sidebarads") ||
        document.getElementById("sidebaradsfirst")
      ) {
        window.addEventListener("load", function () {
          (adsbygoogle = window.adsbygoogle || []).push({});
        });
      }
    },
  };

  Drupal.behaviors.handleHomepageAds = {
    attach: function (context, settings) {
      const featured = document.querySelector(".c-hp--featured");
      const featuredContent = document.querySelector(".c-hp--featured-content");
      const adsContainer = document.querySelector(".adsbygoogle");
      const adsBlock = document.querySelector(
        "#block-sky-history-adshomepagevertical"
      );

      const moveAdsBlock = () => {
        if (featured && adsBlock) {
          featured.classList.add("ads-enabled");
          featuredContent.appendChild(adsBlock);
          adsBlock.style.display = "flex";
        }
      };

      const setAdsFormat = () => {
        if (featured && adsContainer) {
          if (window.innerWidth >= 575) {
            adsContainer.setAttribute("data-ad-format", "vertical");
          } else {
            adsContainer.setAttribute("data-ad-format", "fluid");
          }
          window.adsbygoogle = [];
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        }
      };

      if (window.adsLoaded) {
        return;
      } else {
        window.adsLoaded = true;
        moveAdsBlock();
        setAdsFormat();
      }

      window.addEventListener("resize", function () {
        setTimeout(setAdsFormat, 300);
      });
    },
  };

  Drupal.behaviors.searchToggle = {
    attach: function (context, settings) {
      $("button.c-search--toggle", context).click(function () {
        $("#l-search-top").toggleClass(
          "l-search--unselected l-search--selected"
        );
        document.getElementById("edit-keys").focus();
        $(window).scrollTop(-65);
      });
    },
  };

  Drupal.behaviors.share = {
    attach: function (context, settings) {
      const shareButton = context.querySelector(".share-button");

      if (shareButton) {
        if (navigator.share) {
          shareButton.addEventListener("click", () => {
            // Call the function to create the modified URL with UTM
            const modifiedUrl = createModifiedUrl();

            navigator
              .share({
                title: document.title,
                url: modifiedUrl,
              })
              .then(() => {
                console.log("Shared successfully");
              })
              .catch((error) => {
                console.error("Error sharing:", error);
              });
          });
        } else {
          // Hide the button if the Share API is not supported
          shareButton.style.display = "none";
        }
      } else {
        return;
      }
    },
  };

  Drupal.behaviors.episodeGuide = {
    attach: function (context, settings) {
      // Get all the sections within the current context
      const sections = context.querySelectorAll("[id^=season-]");

      // Get all the links within the current context
      const links = context.querySelectorAll("a[href^='#season-']");

      // Function to hide all sections
      function hideAllSections() {
        sections.forEach((section) => section.classList.add("hidden"));
      }

      // Function to show the highest value section
      function showHighestSection() {
        let highestSection = null;
        sections.forEach((section) => {
          const sectionId = parseInt(section.id.split("-")[1], 10); // Parse the ID as a number
          if (
            !highestSection ||
            sectionId > parseInt(highestSection.id.split("-")[1], 10)
          ) {
            highestSection = section;
          }
        });

        // Hide all sections before showing the highest one
        hideAllSections();

        if (highestSection) {
          highestSection.classList.remove("hidden");
        }
      }

      // Function to show only the clicked section
      function showClickedSection(clickedLink) {
        const clickedSectionId = clickedLink.href.split("#")[1];
        const clickedSection = document.getElementById(clickedSectionId);

        // Hide all sections first
        hideAllSections();

        // Show the clicked section
        clickedSection.classList.remove("hidden");
      }

      // Add event listener to each link
      links.forEach((link) => {
        link.addEventListener("click", (event) => {
          event.preventDefault(); // Prevent default link behavior (scrolling)
          showClickedSection(link);
        });
      });

      // Show the highest section on page load
      showHighestSection();
    },
  };

  Drupal.behaviors.moleculeObserver = {
    attach: function (context, settings) {
      const moleculeText = document.querySelectorAll(".c-molecule--text");
      const searchResult = document.querySelectorAll(".search-solr--result");

      moleculeText.forEach((element) => {
        const title = element.querySelector("h5");

        if (title) {
          const observer = new ResizeObserver(() => {
            if (title.offsetHeight <= 22) {
              element.classList.add("title-one-line");
            } else {
              element.classList.remove("title-one-line");
            }
          });

          observer.observe(title);
        }
      });

      searchResult.forEach((element) => {
        const title = element.querySelector("h5");

        if (title) {
          const observer = new ResizeObserver(() => {
            if (title.offsetHeight <= 28) {
              element.classList.add("title-one-line");
            } else {
              element.classList.remove("title-one-line");
            }
          });

          observer.observe(title);
        }
      });
    },
  };

  Drupal.behaviors.newsletterPopup = {
    attach: function (context, settings) {
      if (document.cookie.indexOf("newsletter_popup=disabled") !== -1) {
        $("#spb-block-sky-history-newsletterpopup").hide();
      } else {
        $("#spb-block-sky-history-newsletterpopup").show();
      }

      function setCookie(name, value, seconds) {
        var date = new Date();
        date.setTime(date.getTime() + seconds * 1000);
        var expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + value + "; " + expires + "; path=/";
      }

      $(document).on("submit", "#mc-embedded-subscribe-form", function (e) {
        setCookie("newsletter_popup", "disabled", 604800);
        $("#spb-block-sky-history-newsletterpopup").hide();
      });

      $(document).on(
        "click",
        ".block-sky-history-newsletterpopup-modal-close",
        function (e) {
          e.preventDefault();
          console.log("FUNCIONANDO!");

          setCookie("newsletter_popup", "disabled", 86400);
          $("#spb-block-sky-history-newsletterpopup").hide();
        }
      );

      window.onload = function () {
        document.querySelector(".newsletter_popup").style.display = "flex";
      };
    },
  };

  Drupal.behaviors.createModifiedUrl = {
    attach: function (context, settings) {
      Drupal.createModifiedUrl = function () {
        const currentUrl = window.location.href;
        const modifiedUrl = new URL(currentUrl);
        modifiedUrl.searchParams.append("utm_source", "share");
        return modifiedUrl.toString();
      };
    },
  };

  Drupal.behaviors.bootstrap_barrio_subtheme = {
    attach: function (context, settings) {
      var position = $(window).scrollTop();
      $(window).scroll(function () {
        if ($(this).scrollTop() > 50) {
          $("body").addClass("scrolled");
        } else {
          $("body").removeClass("scrolled");
        }
        var scroll = $(window).scrollTop();
        if (scroll > position) {
          $("body").addClass("scrolldown");
          $("body").removeClass("scrollup");
        } else {
          $("body").addClass("scrollup");
          $("body").removeClass("scrolldown");
        }
        position = scroll;
      });
    },
  };

  Drupal.behaviors.addAltToImages = {
    attach: function (context, settings) {
      $("img:not([alt])", context).each(function () {
        $(this).attr("alt", "");
      });
    },
  };

  Drupal.behaviors.handleArticlesForm = {
    attach: function (context, settings) {
      const handleArticlesForm = () => {
        let attempts = 0;

        const changeColor = () => {
          const form = document.querySelector(".search-articles form");

          if (form) {
            const select = document.querySelectorAll(
              ".search-articles form select"
            );

            select.forEach((field) => {
              field.style.color = field.value === "All" ? "#6c757d" : "#212529";

              field.addEventListener("change", function () {
                this.style.color = this.value === "All" ? "#6c757d" : "#212529";
              });
            });

            return true;
          } else {
            return false;
          }
        };

        const apply = () => {
          const success = changeColor();
          attempts++;

          if (!success && attempts <= 3) {
            setTimeout(apply, 500);
          }
        };

        apply();
      };

      handleArticlesForm();
    },
  };
})(jQuery, Drupal);
